<template>
  <app-modal
    v-bind="$attrs"
    title="確認"
    ref="modal"
    class="modal-container"
    content-class="modal-full"
  >
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="py-4 px-0">
        <div class="modal-body">
          <v-container fluid class="pa-1">
            <div class="font-weight-bold mb-3">
              ポリシーを設定反映します。よろしいですか？
            </div>
            <v-row>
              <v-col cols="6">
                <app-label-group
                  label="回線番号(メイン)"
                  :value="`${type1Service.enumberMainAct}/${type1Service.enumberMainSby}`"
                />
              </v-col>
              <v-col cols="6">
                <app-label-group
                  label="回線番号(BCP)"
                  :value="`${type1Service.enumberBcpAct}/${type1Service.enumberBcpSby}`"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="VPNコード"
                  :value="type1Service.vpnCode"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group label="Type" value="インターネットType1" />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="セキュリティアプライアンス"
                  value="UTM(1Gbpsベストエフォート)"
                />
              </v-col>
              <v-col cols="12">
                <app-label-group
                  label="状態"
                  :value="$filter.enumTo(type1Service.status, `status`)"
                />
              </v-col>
            </v-row>
            <template
              v-for="obj in displayZoneInfo"
              :key="obj.relation.zoneRelationId"
            >
              <div class="font-weight-bold mt-4">
                {{
                  $filter.enumTo(obj.relation.srcZoneType, "zoneType") +
                  "/" +
                  obj.relation.srcZoneName +
                  " → " +
                  $filter.enumTo(obj.relation.dstZoneType, "zoneType") +
                  "/" +
                  obj.relation.dstZoneName
                }}
              </div>
              <template v-if="contractSummary.isNat">
                <div class="mt-2 text-subtitle-2">
                  {{
                    obj.relation.srcZoneType === "INTERNET"
                      ? "NAT(IP Forwarding)"
                      : "NAT(IP Masquerade)"
                  }}
                </div>
                <v-table
                  density="compact"
                  v-if="obj.relation.srcZoneType === 'INTERNET'"
                >
                  <thead class="v-table-head text-caption">
                    <tr>
                      <th>ID</th>
                      <th>送信元アドレス</th>
                      <th>IPマッピング</th>
                      <th>有効/無効</th>
                      <th>備考</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in obj.natPolicyList" :key="item.policyId">
                      <td>{{ item.policyId }}</td>
                      <td>
                        <policy-src-address
                          :src-address="{ srcAddressList: item.srcAddressList }"
                        />
                      </td>
                      <td>
                        {{
                          "ipMapping" in item && item.ipMapping
                            ? item.ipMapping.ipMappingName
                            : "-"
                        }}
                      </td>
                      <td>
                        {{ $filter.enumTo(item.isPolicyStatus, "enable") }}
                      </td>
                      <td class="text-pre-wrap">
                        {{ $filter.emptyTo(item.description, "-") }}
                      </td>
                    </tr>
                  </tbody>
                </v-table>
                <v-table density="compact" v-else>
                  <thead class="v-table-head text-caption">
                    <tr>
                      <th>ID</th>
                      <th>送信元アドレス</th>
                      <th>宛先アドレス</th>
                      <th>IP Pool</th>
                      <th>有効/無効</th>
                      <th>備考</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in obj.natPolicyList"
                      :key="item.policyId"
                      :class="{
                        'gray-out':
                          'policyCategoryInfo' in item &&
                          item.policyCategoryInfo ===
                            'UNEDITABLE_DEFAULT_POLICY',
                      }"
                    >
                      <td>{{ item.policyId }}</td>
                      <td>
                        <policy-src-address
                          :src-address="{ srcAddressList: item.srcAddressList }"
                        />
                      </td>
                      <td>
                        <policy-dst-address
                          :dst-address="{
                            dstAddressList:
                              'dstAddressList' in item
                                ? item.dstAddressList
                                : [],
                          }"
                        />
                      </td>
                      <td>
                        <policy-ip-pool
                          :ip-pool-list="
                            'ipPoolList' in item ? item.ipPoolList : []
                          "
                        />
                      </td>
                      <td>
                        {{ $filter.enumTo(item.isPolicyStatus, "enable") }}
                      </td>
                      <td class="text-pre-wrap">
                        {{ $filter.emptyTo(item.description, "-") }}
                      </td>
                    </tr>
                  </tbody>
                </v-table>
              </template>
              <div class="mt-3 text-subtitle-2">UTM</div>
              <v-table density="compact">
                <thead class="v-table-head text-caption">
                  <tr>
                    <th>ID</th>
                    <th>送信元アドレス</th>
                    <th>宛先アドレス</th>
                    <th>サービス</th>
                    <th>プロファイル</th>
                    <th>アクション</th>
                    <th>ログ出力</th>
                    <th>有効/無効</th>
                    <th>備考</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="item in obj.utmPolicyList"
                    :key="item.policyId"
                    :class="{
                      'gray-out':
                        item.policyCategoryInfo === 'UNEDITABLE_DEFAULT_POLICY',
                    }"
                  >
                    <td>{{ item.policyId }}</td>
                    <td>
                      <policy-src-address :src-address="item.srcAddress" />
                    </td>
                    <td>
                      <policy-dst-address :dst-address="item.dstAddress" />
                    </td>
                    <td>
                      <policy-service
                        :service-option="item.serviceOption"
                        :default-service-list="item.defaultServiceList"
                        :custom-service-list="item.customServiceList"
                      />
                    </td>
                    <td>
                      <policy-profile :profile="item.profile" />
                    </td>
                    <td>
                      {{ $filter.enumTo(item.actionType, "allow_deny") }}
                    </td>
                    <td>
                      {{ $filter.enumTo(item.isLogOutput, "on_off") }}
                    </td>
                    <td>
                      {{ $filter.enumTo(item.isPolicyStatus, "enable") }}
                    </td>
                    <td class="text-pre-wrap">
                      {{ $filter.emptyTo(item.description, "-") }}
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </template>
          </v-container>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn color="primary" variant="flat" @click="ok">はい</v-btn>
            <v-btn color="primary" variant="outlined" @click="cancel"
              >いいえ
            </v-btn>
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { GetPolicyType1, GetPolicyType4 } from "@/apis/NwPolicyApi";
import PolicySrcAddress from "@/components/policy/PolicySrcAddress.vue";
import PolicyDstAddress from "@/components/policy/PolicyDstAddress.vue";
import PolicyService from "@/components/policy/PolicyService.vue";
import PolicyProfile from "@/components/policy/PolicyProfile.vue";
import PolicyIpPool from "@/components/policy/PolicyIpPool.vue";
import type { Type1Service } from "@/apis/ContractChangeType1Api";
import type { ZoneRelationItem } from "@/apis/ZoneRelationApi";
import type { Type1UTMPolicy } from "@/modals/applianceContractSetting/type1/policy/InternetType1PolicyUtmList.vue";
import { mapState } from "vuex";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

export type Type1NatPolicy =
  | NonNullable<GetPolicyType4["policyIPMasqueradeType4"]>["policyList"][0]
  | NonNullable<GetPolicyType4["policyNatType4"]>["policyList"][0];

export default defineComponent({
  name: "InternetType1PolicyUtmConfirm",
  components: {
    AppLabelGroup,
    PolicyIpPool,
    PolicyProfile,
    PolicyService,
    PolicyDstAddress,
    PolicySrcAddress,
  },
  props: {
    /** type1ポリシー全体 */
    type1Policy: {
      type: Object as PropType<GetPolicyType1>,
      required: true,
    },
    /** サービスメニュー(インターネットType1) */
    type1Service: {
      type: Object as PropType<Type1Service>,
      required: true,
    },
    /** ゾーンリレーション情報一覧 */
    zoneRelationList: {
      type: Array as PropType<ZoneRelationItem[]>,
      required: true,
    },
  },
  computed: {
    ...mapState("user", {
      contractSummary: "contractSummary",
    }),
    displayRelationList(): ZoneRelationItem[] {
      // global -> private
      // global -> extra
      // extra -> global
      // private -> global
      // 上記のみ表示
      return this.zoneRelationList.filter(
        (v) =>
          (v.srcZoneType === "INTERNET" &&
            (v.dstZoneType === "PRIVATE" || v.dstZoneType === "EXTRA")) ||
          ((v.srcZoneType === "PRIVATE" || v.srcZoneType === "EXTRA") &&
            v.dstZoneType === "INTERNET")
      );
    },
    /** 表示用データ整形 */
    displayZoneInfo(): {
      relation: ZoneRelationItem;
      utmPolicyList: Type1UTMPolicy[];
      natPolicyList: Type1NatPolicy[] | null;
    }[] {
      return this.displayRelationList.map((v) => {
        return {
          relation: v,
          utmPolicyList:
            v.srcZoneType === "INTERNET"
              ? this.type1Policy.policyUtmType1?.internetToAccessPointList.find(
                  (item) => item.zoneRelationId === v.zoneRelationId
                )?.policyList ?? []
              : this.type1Policy.policyUtmType1?.accessPointToInternetList.find(
                  (item) => item.zoneRelationId === v.zoneRelationId
                )?.policyList ?? [],
          natPolicyList: this.contractSummary.isNat
            ? v.srcZoneType === "INTERNET"
              ? this.type1Policy.policyNatType1List?.find(
                  (item) => item.zoneRelationId === v.zoneRelationId
                )?.policyList ?? []
              : this.type1Policy.policyIPMasqueradeType1List?.find(
                  (item) => item.zoneRelationId === v.zoneRelationId
                )?.policyList ?? []
            : null,
        };
      });
    },
  },
});
</script>
<style lang="scss" scoped>
th {
  text-align: center !important;
}
td {
  min-width: 60px !important;
}
</style>
